import { render, staticRenderFns } from "./AudiNotification.vue?vue&type=template&id=b89d5eac&scoped=true"
import script from "./AudiNotification.vue?vue&type=script&lang=js"
export * from "./AudiNotification.vue?vue&type=script&lang=js"
import style0 from "./AudiNotification.vue?vue&type=style&index=0&id=b89d5eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.7.4_webpack@5.103.0__ejs@3.1.1_beeed02dd832a1e8a219df4e9dcab5f9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89d5eac",
  null
  
)

export default component.exports